import React from "react";
import Commons from '../../util/commons';
import { QRCodeSVG as QRCode } from 'qrcode.react';

class TemplateComponent extends React.Component {

    wrapText = (text, maxCharsPerLine = 74) => {
        if (!text) return '';
        return text.split('\n').map(line => {
            if (line.length <= maxCharsPerLine) return line;
            const words = line.split(' ');
            const wrappedLines = [];
            let current = '';
            for (const word of words) {
                if ((current + (current ? ' ' : '') + word).length > maxCharsPerLine && current) {
                    wrappedLines.push(current);
                    current = word;
                } else {
                    current = current ? current + ' ' + word : word;
                }
            }
            if (current) wrappedLines.push(current);
            return wrappedLines.join('\n');
        }).join('\n');
    }

    qrcodeValue = (invoiceUid) => {
        return window.location.host + "/mydata/" + invoiceUid;
    }

    getLogo = (logo) => {
        if (!logo) return null;
        if (!logo.includes("blob:")) logo += "?" + Date.now();
        return <img alt="" src={logo} className="logo_img" />;
    }

    createMoreTaxesTable(saleInstanceMoreTaxes, lang) {
        const rows = [];
        const types = [];
        saleInstanceMoreTaxes.sort((a, b) => a.myDataMoreTax.type.localeCompare(b.myDataMoreTax.type));
        saleInstanceMoreTaxes.forEach(e => {
            let type = e.myDataMoreTax.type;
            if (type === "DEDUCTION" && e.myDataMoreTax.label) {
                e.deduction = e.myDataMoreTax;
                e.deduction.name = e.myDataMoreTax.label;
            }
            if (e.deduction) type = "DEDUCTION";
            if (!types.includes(e.myDataMoreTax.type)) {
                types.push(e.myDataMoreTax.type);
            } else {
                type = "";
            }
            const TAX = e.myDataMoreTax ? "TAX_" + e.myDataMoreTax.uid : null;
            if (e.deduction) {
                rows.push(<tr key={Math.random()} className="othertax_row"><td><b>{this.props.t(type, { lng: lang })}</b></td><td>{e.deduction.name}</td><td>{e.amount}</td></tr>);
            } else {
                rows.push(<tr key={Math.random()} className="othertax_row"><td><b>{this.props.t(type, { lng: lang })}</b></td><td>{this.props.t(TAX, { lng: lang })}</td><td>{e.amount}</td></tr>);
            }
        });
        return rows;
    }

    createEntries = (entries) => {
        if (!entries) return [];
        const rowlimit = 15;
        const sale = this.props.sale;
        const lang = sale?.TEMPLATE_LANG;
        const showMu = sale ? !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noMeasurementUnit") : true;

        entries = entries.sort((a, b) => (a.id > b.id) ? 1 : (b.id > a.id ? -1 : 0));
        const diff = rowlimit - entries.length;
        if (diff > 0) {
            for (let i = 0; i < diff - 1; i++) {
                entries.push({ id: "empty_" + i, NAME_LIST: "", QUANTITY_LIST: "", MU_LIST: "", UP_LIST: "", DISCOUNT: "", VAT_LIST: "", PRICE_NOVAT_LIST: "", PRICE_LIST: "" });
            }
        }

        return entries.map(entry => (
            <tr key={"entry_" + entry.id} className="products">
                <td><span className="item_name"><p><small>{entry.NAME_LIST}</small></p></span></td>
                <td><span className="item_quantity"><p>{entry.QUANTITY_LIST}</p></span></td>
                {showMu && <td><span className="item_mu"><p>{this.props.t(entry.MU_LIST, { lng: lang })}</p></span></td>}
                <td><span className="item_unit_price"><p>{entry.UP_LIST}</p></span></td>
                <td><span className="item_discount"><p>{entry.DISCOUNT}</p></span></td>
                <td><span className="item_vat"><p>{entry.VAT_LIST}</p></span></td>
                <td><span className="item_price_novat"><p>{entry.PRICE_NOVAT_LIST}</p></span></td>
                <td><span className="item_price_withvat"><p>{entry.PRICE_LIST}</p></span></td>
            </tr>
        ));
    }

    createPage = (sale) => {
        const lang = sale.TEMPLATE_LANG;
        const t = (key, opts) => this.props.t(key, { lng: lang, ...opts });
        const showMu = !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noMeasurementUnit");
        const showCountItems = !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noCountItems");
        const isSelfDelivery = sale.MYDATA_INVOICE_TYPE === "invoice2_01" || sale.MYDATA_INVOICE_TYPE === "invoice11_02";

        return (
            <div className={"invoice-box " + lang} key={"box_" + Math.floor(Math.random() * 10000)}>
                <div className="top_table">
                    <table><tbody>
                        <tr className="top"><td>
                            <table className="header_table"><tbody>
                                <tr>
                                    <td className="logo_container">{this.getLogo(sale.LOGO)}</td>
                                    <td className="issuer_container">
                                        <span className="issuer_name template_skin">{sale.ISSUER_NAME}</span>
                                        <p><span className="issuer_subjectField template_skin">{sale.ISSUER_SUBJECTFIELD}</span></p>
                                        <p><span className="issuer_address template_skin">{sale.ISSUER_ADDRESS}</span></p>
                                        <p>
                                            <span className="template_skin">{t("TAXPAYER_ID")}: </span><span className="issuer_vat template_skin">{sale.ISSUER_VAT}</span>
                                            &nbsp;
                                            <span className="template_skin">{t("DOY")}: </span><span className="issuer_doy template_skin">{sale.ISSUER_DOY}</span>
                                            &nbsp;
                                            <span className="template_skin">{t("GEMH")}: </span><span className="issuer_gemh template_skin">{sale.ISSUER_GEMH}</span>
                                        </p>
                                        <p>
                                            <span className="template_skin">{t("PHONE")}: </span><span className="issuer_phone template_skin">{sale.ISSUER_PHONE}</span>
                                            &nbsp;
                                            <span className="template_skin">{t("EMAIL")}: </span><span className="issuer_email template_skin">{sale.ISSUER_EMAIL}</span>
                                        </p>
                                        <span className="futureUse"></span>
                                    </td>
                                </tr>
                            </tbody></table>
                        </td></tr>
                    </tbody></table>

                    <div className="main_info">
                        <table><tbody><tr><td>
                            <table className="main_info_table"><tbody>
                                <tr className="heading">
                                    <td><span className="invoice_type">{sale.INVOICE_TYPE}</span></td>
                                    <td><span className="invoice_number">{sale.INVOICE_NUMBER}</span></td>
                                    <td><span className="invoice_date">{sale.INVOICE_DATE}</span></td>
                                    <td><span className="invoice_time">{sale.INVOICE_TIME}</span></td>
                                </tr>
                            </tbody></table>
                        </td></tr></tbody></table>
                    </div>

                    <div className="trafficDataDivisioner">
                        <span>{t("customerSection")}</span>
                    </div>

                    <table className="information_table"><tbody>
                        <tr>
                            <td className="information_td_left">
                                <div className="information left"><table><tbody>
                                    <tr>
                                        <td className="template_skin bold"><span>{t("CP_NAME")}</span></td>
                                        <td className="info_value"><span>: </span><span className="counterparty_name">{sale.CP_NAME}</span></td>
                                    </tr>
                                    <tr>
                                        <td className="template_skin bold"><span>{t("TAXPAYER_ID")}</span></td>
                                        <td className="info_value"><span>: </span><span className="counterparty_vat">{sale.CP_VAT}</span></td>
                                    </tr>
                                    <tr>
                                        <td className="template_skin bold"><span>{t("CP_SUBJECT_FIELD")}</span></td>
                                        <td className="info_value"><span>: </span><span className="counterparty_activity">{sale.CP_SUBJECT_FIELD}</span></td>
                                    </tr>
                                    <tr>
                                        <td className="template_skin bold"><span>{t("DOY")}</span></td>
                                        <td className="info_value"><span>: </span><span className="counterparty_doy">{sale.CP_TAXOFFICE}</span></td>
                                    </tr>
                                </tbody></table></div>
                            </td>
                            <td> </td>
                            <td className="information_td_right">
                                <div className="information right"><table><tbody>
                                    <tr>
                                        <td className="template_skin bold"><span>{t("CP_PAYTYPE")}</span></td>
                                        <td className="info_value"><span>: </span><span className="counterparty_paytype">{t(sale.CP_PAYTYPE)}</span></td>
                                    </tr>
                                    <tr>
                                        <td className="template_skin bold"><span>{t("COUNTRY")}</span></td>
                                        <td className="info_value"><span>: </span><span className="counterparty_country">{t(sale.COUNTRY)}</span></td>
                                    </tr>
                                    {sale.CP_CITY && <tr>
                                        <td className="template_skin bold"><span>{t("CP_CITY")}</span></td>
                                        <td className="info_value"><span>: </span><span className="counterparty_city">{sale.CP_CITY}</span></td>
                                    </tr>}
                                    {sale.CP_ADDRESS && <tr>
                                        <td className="template_skin bold"><span>{t("CP_ADDRESS")}</span></td>
                                        <td className="info_value"><span>: </span><span className="counterparty_address">{sale.CP_ADDRESS}</span></td>
                                    </tr>}
                                </tbody></table></div>
                            </td>
                        </tr>
                    </tbody></table>

                    {showCountItems && (
                        <div className="trafficDataDivisioner">
                            <span>{t("moveSection")}</span>
                        </div>
                    )}

                    <table className="information_table"><tbody>
                        <tr>
                            <td className="information_td_left">
                                <div className="information left"><table><tbody>
                                    {sale.MOVE_PURPOSE && (
                                        <tr>
                                            <td className="template_skin bold"><span>{t("MOVE_PURPOSE")}</span></td>
                                            <td className="info_value"><span>: </span><span className="move_purpose">{sale.MOVE_PURPOSE}</span></td>
                                        </tr>
                                    )}
                                    {sale.LOADING_ADDRESS && (
                                        <tr>
                                            <td className="template_skin bold"><span>{t("LOADING_ADDRESS")}</span></td>
                                            <td className="info_value"><span>: </span><span className="loading_address">{sale.LOADING_ADDRESS}</span></td>
                                        </tr>
                                    )}
                                </tbody></table></div>
                            </td>
                            <td> </td>
                            <td className="information_td_right">
                                <div className="information right"><table><tbody>
                                    {sale.VEHICLE_NUMBER && (
                                        <tr>
                                            <td className="template_skin bold"><span>{t("VEHICLE_NUMBER")}</span></td>
                                            <td className="info_value"><span>: </span><span className="vahicle_number">{sale.VEHICLE_NUMBER}</span></td>
                                        </tr>
                                    )}
                                    {sale.DISPATCH_DATE && (
                                        <tr>
                                            <td className="template_skin bold"><span>{t("DISPATCH_DATE")}</span></td>
                                            <td className="info_value"><span>: </span><span className="dispatch_date">{sale.DISPATCH_DATE}</span></td>
                                        </tr>
                                    )}
                                    {sale.DELIVERY_ADDRESS && (
                                        <tr>
                                            <td className="template_skin bold"><span>{t("DELIVERY_ADDRESS")}</span></td>
                                            <td className="info_value"><span>: </span><span className="delivery_address">{sale.DELIVERY_ADDRESS}</span></td>
                                        </tr>
                                    )}
                                </tbody></table></div>
                            </td>
                        </tr>
                    </tbody></table>

                    {isSelfDelivery && (
                        <>
                            <div className="main_info">
                                <table><tbody><tr><td>
                                    <table className="main_info_table"><tbody>
                                        <tr className="heading">
                                            <td><p>{t("senderName")}</p></td>
                                            <td><p>{t("recipientName")}</p></td>
                                        </tr>
                                    </tbody></table>
                                </td></tr></tbody></table>
                            </div>
                            <table className="information_table"><tbody>
                                <tr>
                                    <td className="information_td_left">
                                        <div className="information left"><table><tbody>
                                            <tr>
                                                <td className="template_skin bold"><span>{t("CP_NAME")}</span></td>
                                                <td className="info_value"><span>: </span><span className="counterparty_name">{sale.SENDER_NAME}</span></td>
                                            </tr>
                                            <tr>
                                                <td className="template_skin bold"><span>{t("TAXPAYER_ID")}</span></td>
                                                <td className="info_value"><span>: </span><span className="counterparty_name">{sale.SENDER_TAXPAYER_ID}</span></td>
                                            </tr>
                                        </tbody></table></div>
                                    </td>
                                    <td></td>
                                    <td className="information_td_right">
                                        <div className="information right"><table><tbody>
                                            <tr>
                                                <td className="template_skin bold"><span>{t("CP_NAME")}</span></td>
                                                <td className="info_value"><span>: </span><span className="counterparty_name">{sale.RECIPIENT_NAME}</span></td>
                                            </tr>
                                            <tr>
                                                <td className="template_skin bold"><span>{t("TAXPAYER_ID")}</span></td>
                                                <td className="info_value"><span>: </span><span className="counterparty_name">{sale.RECIPIENT_TAXPAYER_ID}</span></td>
                                            </tr>
                                        </tbody></table></div>
                                    </td>
                                </tr>
                            </tbody></table>
                        </>
                    )}
                </div>

                <div className="product_container">
                    <div className="background_img_container"></div>
                    <table className="product_table">
                        <thead>
                            <tr className="heading">
                                <td className="description_head_td"><p>{t("PROD_SERV")}</p></td>
                                <td className="quantity_head_td"><p>{t("QUANTITY")}</p></td>
                                {showMu && <td className="mu_head_td"><p>{t("MUN")}</p></td>}
                                <td className="up_head_td"><p>{t("UNIT_PRICE")}</p></td>
                                <td className="disc_head_td"><p>{t("DISCOUNT")}</p></td>
                                <td className="vat_head_td"><p>{t("VAT")} %</p></td>
                                <td className="pricenovat_head_td"><p>{t("PRICE_WITHOUT_VAT")}</p></td>
                                <td className="price_head_td"><p>{t("PRICE_WITH_VAT")}</p></td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.createEntries(sale.entries)}
                        </tbody>
                    </table>
                </div>

                <div className="footer_container">
                    <table className="footer_table"><tbody>
                        <tr>
                            <td>
                                <table><tbody>
                                    <tr>
                                        <td>
                                            <div className="cont_notation">
                                                <span className="template_skin bold">{t("NOTES")}</span>
                                                <div className="cont_notation_inner">
                                                    <span className="notes" style={{ whiteSpace: 'pre-wrap' }}>{this.wrapText(sale.NOTES)}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <table className="taxes_details_table"><tbody>
                                                <tr>
                                                    <td className="qrcodeimg_container">
                                                        <span className="qrcode_img">
                                                            <QRCode
                                                                size={100}
                                                                bgColor="#ffffff"
                                                                fgColor="#000000"
                                                                level="L"
                                                                marginSize={0}
                                                                value={sale.QRURL ? sale.QRURL : this.qrcodeValue(sale.INVOICEUID)}
                                                            />
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div className="taxes_details">
                                                            <table><tbody>
                                                                {sale.saleInstanceMoreTaxes && this.createMoreTaxesTable(sale.saleInstanceMoreTaxes, lang)}
                                                            </tbody></table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody></table>
                                        </td>
                                    </tr>
                                    {sale.VAT_EXCEPTION_CATEGORIES?.[0] && (
                                        <tr>
                                            <td><small><b>{t("vatCategoryExceptionShort")} </b><span className="vat_exception_span">{t(sale.VAT_EXCEPTION_CATEGORIES[0])}</span></small></td>
                                        </tr>
                                    )}
                                    {sale.MOREINFO && (
                                        <tr>
                                            <td className="morenfo_sign">{this.props.t(sale.MOREINFO)}</td>
                                        </tr>
                                    )}
                                </tbody></table>
                            </td>

                            <td>
                                {showCountItems && (
                                    <div className="count_totals_container">
                                        <span>{t("TOTALITEMS")}: </span>
                                        <span className="count_total_prods">{sale.TOTALCOUNTITEMS}</span>
                                    </div>
                                )}
                                <div className="total_container">
                                    <div className="totals">
                                        <table className="totals_table"><tbody>
                                            <tr>
                                                <td className="text-left"><p>{t("TOTALVALUE")}</p></td>
                                                <td className="text-right"><p><span className="total_nodiscount">{sale.TOTALNODISCOUNT}</span></p></td>
                                            </tr>
                                            <tr>
                                                <td className="text-left"><p>{t("DISCOUNT")}</p></td>
                                                <td className="text-right"><p><span className="total_discount">{sale.TOTALDISCOUNT}</span></p></td>
                                            </tr>
                                            <tr>
                                                <td className="text-left"><p>{t("VATVALUE")}</p></td>
                                                <td className="text-right"><p><span className="total_withoutvat">{sale.TOTALVAT}</span></p></td>
                                            </tr>
                                            <tr>
                                                <td className="text-left"><p>{t("MORETAXES")}</p></td>
                                                <td className="text-right"><p><span className="total_whtaxes">{sale.TOTALTAXES}</span></p></td>
                                            </tr>
                                            <tr>
                                                <td className="text-left finalprice"><p>{t("PAYAMOUNT")}</p></td>
                                                <td className="text-right finalpricevalue"><p><span className="totalpayment">{sale.TOTALPAYMENT}</span></p></td>
                                            </tr>
                                            {sale.CURRENCY && sale.CURRENCY !== "EUR" && (
                                                <tr>
                                                    <td className="text-left finalprice"><p>{t("TOTALPAYMENT_ON_CURRENCY", { currency: sale.CURRENCY })}</p></td>
                                                    <td className="text-right finalpricevalue"><p><span className="totalpayment_on_currency">{sale.TOTALPAYMENT_ON_CURRENCY}</span> <span className="currency">{sale.CURRENCY}</span></p></td>
                                                </tr>
                                            )}
                                        </tbody></table>
                                        <div className="total_funny_box"></div>
                                    </div>
                                </div>
                                <table><tbody>
                                    <tr>
                                        <td style={{ textAlign: "center" }}>
                                            {sale.IBAN && <span className="iban_sign">{sale.IBAN}</span>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span className="cont_signs">
                                                <div className="cont_sign_left">
                                                    <span className="sign_left">{t("ISSUANCE")}</span>
                                                    <br /><br /><br /><br />
                                                    <hr className="sign_hr" />
                                                    <span className="fullname_sign">{t("Signature")}</span>
                                                </div>
                                                <div className="cont_sign_right">
                                                    <span className="sign_right">{t("RECEIPT")}</span>
                                                    <br /><br /><br /><br />
                                                    <hr className="sign_hr" />
                                                    <span className="fullname_sign">{t("Signature")}</span>
                                                </div>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody></table>
                            </td>
                        </tr>
                        {sale.CORRELATIVE_INVOICE && (
                            <tr>
                                <td><small>{this.props.t("correlativeSales")}: <span className="corr_invoice_span">{this.props.t(sale.CORRELATIVE_INVOICE)}</span></small></td>
                            </tr>
                        )}
                    </tbody></table>

                    <div className="mydata_footer">
                        <table><tbody>
                            <tr>
                                <td>
                                    <span className="mydata_sign">
                                        <table><tbody>
                                            <tr>
                                                <td>{sale.INVOICEUID && <><span>uid: </span><span className="uid_sign">{sale.INVOICEUID}</span></>}</td>
                                                <td>{sale.INVOICEMARK ? <><span>mark: </span><span className="mark_sign">{sale.INVOICEMARK}</span></> : (sale.TRANSMISSION_FAILURE == 1 ? <span className="notTransmitted"><b>{this.props.t("transmissionFailure")}</b></span> : <span className="notPublished"><b>{this.props.t("notPublished")}</b></span>)}</td>
                                                <td>{sale.CANCELATIONMARK && <><span>cancelationMark: </span><span className="mark_sign">{sale.CANCELATIONMARK}</span></>}</td>
                                            </tr>
                                        </tbody></table>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td><span className="sender_sign">{t("CREATEDBY")}</span></td>
                            </tr>
                        </tbody></table>
                    </div>
                </div>
            </div>
        );
    }

    createPages = (sale) => {
        const pages = [];
        const chunk = 12;
        if (sale && sale.INVOICE_ENTRIES !== undefined) {
            for (let i = 0, j = sale.INVOICE_ENTRIES.length; i < j; i += chunk) {
                const groupEntries = sale.INVOICE_ENTRIES.slice(i, i + chunk);
                const groupSale = Object.assign({}, sale, { entries: groupEntries });
                pages.push(this.createPage(groupSale));
            }
        }
        return pages;
    }

    getMainStyle = () => {
        if (this.props.mainStyle) return <style>{this.props.mainStyle}</style>;
    }

    getExtraCss = () => {
        if (this.props.extracss) return <style>{this.props.extracss}</style>;
    }

    render() {
        return (
            <div id="template_page" className="page template_page">
                <link type="text/css" rel="stylesheet" href="../template-simple.css" />
                <link href="https://fonts.googleapis.com/css?family=Open+Sans&family=Ubuntu&family=GFS+Neohellenic" rel="stylesheet" type="text/css" />
                {this.getMainStyle()}
                {this.getExtraCss()}
                {this.createPages(this.props.sale)}
            </div>
        );
    }
}

export default TemplateComponent;
